module.exports = __webpack_public_path__ + "img/Synthetic_SEO.fed666e2.jpg";